import { useState } from 'react';
import { Button, ChipToggle, Dialog, Field, Input } from '@/components/ui';
import {
  SEE_FIRST_LABELS,
  type QueueTicket,
  type SeeFirstFlag,
} from '@/features/queue/types';
import styles from './queue.module.css';

const FLAGS = Object.keys(SEE_FIRST_LABELS) as SeeFirstFlag[];

/** Admin v2 "See first": a red-flag reason is required and logged. */
export function SeeFirstDrawer({
  ticket,
  onClose,
  onConfirm,
  busy,
}: {
  ticket: QueueTicket | null;
  onClose: () => void;
  onConfirm: (flag: SeeFirstFlag, note: string) => void;
  busy?: boolean;
}) {
  const [flag, setFlag] = useState<SeeFirstFlag | null>(null);
  const [note, setNote] = useState('');
  return (
    <Dialog
      open={!!ticket}
      onClose={onClose}
      title={`See first · ${ticket?.patient.fullName ?? ''}`}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            variant="primary"
            disabled={!flag}
            loading={busy}
            onClick={() => flag && onConfirm(flag, note.trim())}
          >
            Move to the front
          </Button>
        </>
      }
    >
      <div className={styles.drawer}>
        <p className={styles.warnNote}>
          Move a patient ahead only for a red-flag reason. Everyone else keeps
          their place, and the reason is logged.
        </p>
        <div className={styles.section}>
          <p className="eyebrow">Red flag</p>
          <ChipToggle
            label="Red flag"
            single
            options={FLAGS.map((f) => ({
              value: f,
              label: SEE_FIRST_LABELS[f],
            }))}
            selected={flag ? [flag] : []}
            onChange={([f]) => setFlag(f)}
          />
        </div>
        <Field
          label={
            <>
              Note <span className={styles.optional}>optional</span>
            </>
          }
        >
          <Input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. pain started 20 minutes ago"
          />
        </Field>
      </div>
    </Dialog>
  );
}
